module.exports = __webpack_public_path__ + "img/humi_dash.398204bf.svg";